import { Component, HostBinding, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { SchemaService } from '@fcom/common/services/schema/schema.service';

import { FeedbackService } from '../../services/feedback/feedback.service';
import { QualtricsSurveys } from '../../qualtrics/qualtrics.utils';

@Component({
  selector: 'fin-front-page',
  styleUrls: ['./front-page.component.scss'],
  templateUrl: './front-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FrontPageComponent implements OnInit, OnDestroy {
  private feedbackService = inject(FeedbackService);
  private schemaService = inject(SchemaService);

  @HostBinding('class.col-f') defaultClass = true;

  ngOnInit(): void {
    this.schemaService.addAirlineSchema();
    this.schemaService.addWebSiteSchema();
    this.feedbackService.setSurvey(QualtricsSurveys.FEEDBACK);
    this.feedbackService.setFeedbackWidgetVisibility(true);
  }

  ngOnDestroy(): void {
    this.feedbackService.setFeedbackWidgetVisibility(false);
  }
}
